module.exports = __webpack_public_path__ + "static/media/icnBtnGuardarYConfirmar.6244cc28.svg";